import { Controller } from "stimulus";

export default class extends Controller {
  connect(){
    this.initializeTestResultValidation(this.element)
  }
  
  
  initializeTestResultValidation (within) {
    function resultMayBeRequired (result) {
      const sts = result.closest('[data-specimen-test-schedule]');
  
      // This isn't a panel, so any required results are required unconditionally.
      if (sts == null || isFalse(sts.dataset.isPanel)) {
        return true;
      }
  
      const group = result.closest('[data-specimen-test-schedule-group]');
  
      if (group == null) {
        return true;
      }
  
      // This is a panel, but it's being entered individually, so we require unconditionally.
      if (group.querySelectorAll('[data-specimen-test-schedule]').length === 1) {
        return true;
      }
  
      // This is a panel, and it's not being entered individually, so we require
      // test-results only when any test-results are provided for the panel-member.
      if ($(sts).find(':filled:not([type = "hidden"]):not([type = "radio"]:unchecked):not([type = "checkbox"]:unchecked):not([type = "submit"]):not([type = "button"]):not(button), [data-canned-comment-result]').length > 0) {
        return true;
      }
  
      return false;
    }
  
    $(within).each(function() {
      let inputsWithin = $(within);
  
      if (this.dataset.validationInitialized !== 'true') {
        var validator = $(this).validate({
          ignore: ".ignore",
          errorPlacement: function (error, element) {
            if (element.is(":hidden")) {
              error.insertAfter(element.parent());
            } else if (element.hasClass("formula-variable")) {
              element.parent().append(error);
            } else {
              element.parent().parent().find('.error-container').append(error);
            }
          }
        });
      }
  
      this.dataset.validationInitialized = 'true';
  
      inputsWithin.find('.form-control.required-answer').each(function () {
        $(this).rules('add', {
          required: {depends: resultMayBeRequired},
          messages: {
            required: $.t('Required input')
          }
        });
      });
  
      inputsWithin.find('.form-control.formula-variable.required-answer').each(function () {
        $(this).rules('add', {
          required: {depends: resultMayBeRequired},
          messages: {
            required: $.t('All formula variables are required input')
          }
        });
      });
  
      inputsWithin.find('.canned_comment_hidden_field.required-answer').each(function () {
        $(this).rules('add', {
          required: {depends: resultMayBeRequired},
          messages: {
            required: $.t('This Canned Comment is a required input')
          }
        });
      });
  
      inputsWithin.find('.wysiwyg-text-box').each(function () {
        $(this).rules('add', {
          required: false,
          maxlength: 10000
        });
      });
  
      var allCheckboxClassNames = inputsWithin.find("input.required-answer[type=checkbox]").map(function () {
        return $(this).attr('name');
      }).get();
  
      var checkboxClassNames = $.unique(allCheckboxClassNames);
  
      $.each(checkboxClassNames, function (i, n) {
        $.validator.addMethod(n, function (value, element) {
          return $("." + n + ":checked").length > 0;
        });
      });
  
      $.each(checkboxClassNames, function (i, n) {
        $("input[name='" + n + "']").each(function () {
          $(this).rules('add', {
            required: {depends: resultMayBeRequired},
            messages: {
              required: $.t('Minimum of one checkbox must be selected')
            }
          });
        });
      });
  
      var allRadioClassNames = inputsWithin.find("input.required-answer:radio").map(function () {
        return $(this).attr('name');
      }).get();
  
      var radioClassNames = $.unique(allRadioClassNames);
  
      $.each(radioClassNames, function (i, n) {
        $.validator.addMethod(n, function (value, element) {
          return $("." + n + ":checked").length > 0;
        });
      });
  
      $.each(radioClassNames, function (i, n) {
        $("input[name='" + n + "']").each(function () {
          $(this).rules('add', {
            required: {depends: resultMayBeRequired},
            messages: {
              required: $.t('Required Input')
            }
          });
        });
      });
  
      // Remove canned comment error message when value has been filled
      $(document).offOn('change', 'input.required-answer:hidden', function () {
        if (validator.check(this) == true) {
          $(this).parent().find('.error-container').empty();
        };
      });
  
      // Remove datepicker error message when value has been filled
      $('input.bootstrap-datepicker').offOn('hide', function () {
        if (validator.check(this) == true) {
          $(this).parent().parent().find('.error-container').empty();
          $(this).removeClass('error');
        };
      });
  
      // validates combobox on change and removes warning label
      $(document).offOn('change', '.combobox', function () {
        var selected = $(this).find("option:selected").val();
        if (selected && $(this).hasClass('required-answer')) {
          $(this).find('label').remove();
        }
      })
  
      // gets canned comment id to append text to div 
      $(document).offOn("click", ".cannedCommentResults", function () {
        $('#canned_comment_modal').modal('show');
        var divKey = $(this).attr("data-keyidx")
        var $divInput = $("<input>", {
          'type': 'hidden',
          'name': 'div_identifier',
          'value': divKey
        });
        $('.modal-footer').append($divInput);
      })
  
  
      $(document).offOn("click", ".pick-comment-button", function () {
        var cannedCommentIdx = $(this).attr("data-id")
        var cannedCommentDiv = $('.modal-footer').find("input[name='div_identifier']").val();
  
        $.ajax({
          url: "/canned_comments/" + cannedCommentIdx,
          dataType: "json",
          type: 'GET',
          success: function (data) {
            $('#canned_comment_hidden_' + cannedCommentDiv).val(data.id)
            $('#canned_comment_hidden_' + cannedCommentDiv).trigger('change')
            $('.canned_comment_' + cannedCommentDiv).empty()
            $('.canned_comment_' + cannedCommentDiv).append(data.comment)
            $("input[name='div_identifier']").remove()
          }
        });
      });
    })
  };
}
